import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7c9ad853")

_pushScopeId("data-v-7c9ad853")
const _hoisted_1 = { class: "kn-page p-d-flex p-flex-row custom-kn-page-width" }
const _hoisted_2 = { class: "kn-list-item-text" }
const _hoisted_3 = {
  key: 1,
  class: "menu-accordion"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "fas fa-folder" }, null, -1)
const _hoisted_5 = { class: "p-ml-2" }
const _hoisted_6 = {
  key: 0,
  class: "pi pi-chevron-right menu-accordion-icon"
}
const _hoisted_7 = {
  key: 1,
  class: "pi pi-chevron-down menu-accordion-icon"
}
const _hoisted_8 = {
  id: "qbe-iframe-container",
  class: "p-d-flex p-flex-row kn-flex"
}
const _hoisted_9 = { class: "kn-list-item-text p-ml-2" }
const _hoisted_10 = {
  key: 1,
  class: "menu-accordion-sidebar"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fas fa-folder" }, null, -1)
const _hoisted_12 = { class: "p-ml-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_WorkspaceDocumentTree = _resolveComponent("WorkspaceDocumentTree")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Button = _resolveComponent("Button")
  const _component_router_view = _resolveComponent("router-view")
  const _component_KnParameterSidebar = _resolveComponent("KnParameterSidebar")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_WorkspaceNewFolderDialog = _resolveComponent("WorkspaceNewFolderDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        id: "sideMenu",
        class: "kn-list--column",
        style: _ctx.workspaceDescriptor.style.menuWidth
      }, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('workspace.menuLabels.menuTitle')), 1)
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        (_ctx.displayMenu && _ctx.storeFunctionalitiesExist)
          ? (_openBlock(), _createBlock(_component_Listbox, {
              key: 1,
              options: _ctx.menuItems,
              "data-test": "menu-list",
              class: "kn-list"
            }, {
              option: _withId((slotProps) => [
                (slotProps.option.value !== 'repository')
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "kn-list-item",
                      onClick: ($event: any) => (_ctx.setActiveView(`/workspace/${slotProps.option.value}`))
                    }, [
                      _createVNode("i", {
                        class: slotProps.option.icon
                      }, null, 2),
                      _createVNode("div", _hoisted_2, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                      ])
                    ], 8, ["onClick"]))
                  : _withDirectives((_openBlock(), _createBlock("div", _hoisted_3, [
                      _createVNode(_component_Accordion, null, {
                        default: _withId(() => [
                          _createVNode(_component_AccordionTab, null, {
                            header: _withId(() => [
                              _createVNode("div", {
                                class: "p-d-flex p-flex-row",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.accordionIcon = !_ctx.accordionIcon)),
                                "data-test": "document-accordion"
                              }, [
                                _hoisted_4,
                                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('workspace.menuLabels.myRepository')), 1),
                                (_ctx.accordionIcon)
                                  ? (_openBlock(), _createBlock("i", _hoisted_6))
                                  : _createCommentVNode("", true),
                                (!_ctx.accordionIcon)
                                  ? (_openBlock(), _createBlock("i", _hoisted_7))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            default: _withId(() => [
                              _createVNode(_component_WorkspaceDocumentTree, {
                                propFolders: _ctx.allFolders,
                                mode: "select",
                                selectedBreadcrumb: _ctx.selectedBreadcrumb,
                                onFolderSelected: _ctx.setSelectedFolder,
                                onDelete: _ctx.deleteFolder,
                                onCreateFolder: _ctx.showCreateFolderDialog,
                                "data-test": "document-tree"
                              }, null, 8, ["propFolders", "selectedBreadcrumb", "onFolderSelected", "onDelete", "onCreateFolder"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 512)), [
                      [_vShow, _ctx.showRepository]
                    ])
              ]),
              _: 1
            }, 8, ["options"]))
          : _createCommentVNode("", true)
      ], 4),
      _createVNode("div", {
        class: "p-d-flex p-flex-column",
        style: _ctx.workspaceDescriptor.style.maxWidth
      }, [
        (_ctx.$router.currentRoute._rawValue.fullPath === '/workspace')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              id: "showSidenavIcon",
              icon: "fas fa-bars",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sidebarVisible = true))
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_view, {
          class: "kn-router-view",
          selectedFolder: _ctx.selectedFolder,
          allFolders: _ctx.allFolders,
          toggleCardDisplay: _ctx.toggleCardDisplay,
          breadcrumbs: _ctx.breadcrumbs,
          onToggleDisplayView: _ctx.toggleDisplayView,
          onShowMenu: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sidebarVisible = true)),
          onReloadRepositoryMenu: _ctx.getAllFolders,
          onBreadcrumbClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setSelectedBreadcrumb($event))),
          onExecute: _cache[5] || (_cache[5] = ($event: any) => (_ctx.executeDocument($event))),
          onShowQbeDialog: _ctx.prepareDataForQbe
        }, null, 8, ["selectedFolder", "allFolders", "toggleCardDisplay", "breadcrumbs", "onToggleDisplayView", "onReloadRepositoryMenu", "onShowQbeDialog"])
      ], 4),
      _createVNode(_component_Dialog, {
        class: "metaweb-dialog remove-padding p-fluid",
        contentStyle: _ctx.workspaceDescriptor.style.flex,
        visible: _ctx.qbeDialogVisible,
        modal: false,
        closable: false,
        position: "right",
        baseZIndex: 1,
        autoZIndex: true
      }, {
        header: _withId(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
            start: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.qbeDataset.name), 1)
            ]),
            end: _withId(() => [
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-filter",
                class: "p-button-text p-button-rounded p-button-plain",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.parameterSidebarVisible = !_ctx.parameterSidebarVisible))
              }, null, 512), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.save'),
                  void 0,
                  { bottom: true }
                ]
              ]),
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-save",
                class: "p-button-text p-button-rounded p-button-plain",
                onClick: _ctx.saveQbeDataset
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.save'),
                  void 0,
                  { bottom: true }
                ]
              ]),
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-times",
                class: "p-button-text p-button-rounded p-button-plain",
                onClick: _ctx.closeQbeIframe
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.close'),
                  void 0,
                  { bottom: true }
                ]
              ])
            ]),
            _: 1
          })
        ]),
        default: _withId(() => [
          _createVNode("div", _hoisted_8, [
            (_ctx.qbeIframeVisible)
              ? (_openBlock(), _createBlock("iframe", {
                  key: 0,
                  id: "qbeIframe",
                  ref: "qbeIframe",
                  class: "kn-width-full kn-height-full",
                  src: _ctx.qbeUrl
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (_ctx.parameterSidebarVisible)
              ? (_openBlock(), _createBlock(_component_KnParameterSidebar, {
                  key: 1,
                  style: {"position":"inherit","margin-left":"auto"},
                  filtersData: _ctx.filtersData,
                  propDocument: _ctx.qbeDataset,
                  userRole: _ctx.userRole,
                  propQBEParameters: _ctx.qbeParameters,
                  propMode: 'qbeView',
                  onExecute: _ctx.initiateQbeIframe
                }, null, 8, ["filtersData", "propDocument", "userRole", "propQBEParameters", "onExecute"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["contentStyle", "visible"])
    ]),
    _createVNode(_component_Sidebar, {
      class: "mySidebar",
      visible: _ctx.sidebarVisible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.sidebarVisible = $event)),
      showCloseIcon: false
    }, {
      default: _withId(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('workspace.menuLabels.menuTitle')), 1)
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Listbox, { options: _ctx.menuItems }, {
          option: _withId((slotProps) => [
            (slotProps.option.value !== 'repository')
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "kn-list-item p-d-flex p-flex-row",
                  onClick: ($event: any) => (_ctx.setActiveView(`/workspace/${slotProps.option.value}`))
                }, [
                  _createVNode("i", {
                    class: slotProps.option.icon
                  }, null, 2),
                  _createVNode("div", _hoisted_9, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                  ])
                ], 8, ["onClick"]))
              : _withDirectives((_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode(_component_Accordion, null, {
                    default: _withId(() => [
                      _createVNode(_component_AccordionTab, null, {
                        header: _withId(() => [
                          _createVNode("div", {
                            class: "p-d-flex p-flex-row",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.accordionIcon = !_ctx.accordionIcon)),
                            "data-test": "document-accordion"
                          }, [
                            _hoisted_11,
                            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('workspace.menuLabels.myRepository')), 1)
                          ])
                        ]),
                        default: _withId(() => [
                          _createVNode(_component_WorkspaceDocumentTree, {
                            propFolders: _ctx.allFolders,
                            mode: "select",
                            selectedBreadcrumb: _ctx.selectedBreadcrumb,
                            onFolderSelected: _ctx.setSelectedFolder,
                            onDelete: _ctx.deleteFolder,
                            onCreateFolder: _ctx.showCreateFolderDialog,
                            "data-test": "document-tree"
                          }, null, 8, ["propFolders", "selectedBreadcrumb", "onFolderSelected", "onDelete", "onCreateFolder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 512)), [
                  [_vShow, _ctx.showRepository]
                ])
          ]),
          _: 1
        }, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_WorkspaceNewFolderDialog, {
      visible: _ctx.displayCreateFolderDialog,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayCreateFolderDialog = false)),
      onCreate: _ctx.createNewFolder
    }, null, 8, ["visible", "onCreate"])
  ], 64))
})